<app-map-view
[mapType]="MapTypes.Trips"
[loading]="false"
[geoJsonDataLayers]="[]"
></app-map-view>
